/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MAbbreviateCardIconComponent as ɵa} from './abbreviate-card-icon.component';